import { ActionTracker } from '@dpdgroupuk/react-event-tracker';

export default new ActionTracker({
  projectRef: 'GREEN',
  debug: false,
  url: `${process.env.REACT_APP_LIVE_STATS_API}/green/analytics`,
});
